(function () {
  "use strict";
  var GIFT_VARIANT_ID = 67171071787181;
  var GIFT_THRESHOLD = 189900;
  var busy = false, pending = false;
  var rawFetch = window.fetch.bind(window);

  function cartJson() {
    return rawFetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("Unable to read cart");
      return r.json();
    });
  }
  function postCart(path, body) {
    return rawFetch(path, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("Cart update failed");
      return r.json();
    });
  }
  function sumWithoutGift(cart, field) {
    return cart.items.reduce(function (sum, item) {
      return Number(item.variant_id) === GIFT_VARIANT_ID ? sum : sum + Number(item[field] || 0);
    }, 0);
  }
  function paint(cart) {
    var subtotal = sumWithoutGift(cart, "final_line_price");
    var shippingThreshold = (window.theme && window.theme.freeShippingThreshold) || 79900;
    var shipLeft = shippingThreshold - subtotal;
    var giftLeft = GIFT_THRESHOLD - subtotal;
    var note = document.querySelector("[data-ship-note]");
    if (note) {
      note.style.display = "block";
      note.style.lineHeight = "1.45";
      var shipText = shipLeft > 0 ? "🚚 Add " + money(shipLeft) + " more for free shipping" : "✓ Free shipping unlocked";
      var giftText = giftLeft > 0 ? "🎁 Add " + money(giftLeft) + " more to unlock FREE ₹699 saree" : "🎉 FREE ₹699 surprise saree unlocked";
      note.innerHTML = '<span style="display:flex;flex-direction:column;gap:4px;width:100%"><span>' + shipText +
        '</span><span style="font-size:11px;font-weight:800;color:#28583a">' + giftText + '</span></span>';
      note.classList.toggle("ship-note--unlocked", shipLeft <= 0 && giftLeft <= 0);
    }
    var sub = document.querySelector("[data-subtotal]");
    if (sub) sub.textContent = money(subtotal);
    cart.items.forEach(function (item) {
      if (Number(item.variant_id) !== GIFT_VARIANT_ID) return;
      var line = document.querySelector('.cart-line[data-key="' + CSS.escape(item.key) + '"]');
      if (!line) return;
      var stepper = line.querySelector(".qty-stepper");
      if (stepper) stepper.outerHTML = '<span style="display:inline-flex;border-radius:999px;padding:.35rem .65rem;background:#edf5e9;color:#234b2a;font-size:11px;font-weight:800">🎁 FREE GIFT</span>';
      var price = line.querySelector(".cart-line__price");
      if (price) price.textContent = "FREE";
      var remove = line.querySelector("[data-remove]");
      if (remove) remove.style.display = "none";
    });
  }
  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "₹{{amount}}";
    var value = (Number(cents) / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, value);
  }
  function syncGift() {
    if (busy) { pending = true; return; }
    busy = true;
    cartJson().then(function (cart) {
      var gifts = cart.items.filter(function (item) { return Number(item.variant_id) === GIFT_VARIANT_ID; });
      var eligible = sumWithoutGift(cart, "original_line_price") >= GIFT_THRESHOLD;
      if (eligible && gifts.length === 0) {
        return postCart("/cart/add.js", { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { "_hapnuts_free_gift": "true" } }] });
      }
      if (!eligible && gifts.length) {
        return Promise.all(gifts.map(function (item) { return postCart("/cart/change.js", { id: item.key, quantity: 0 }); }));
      }
      if (eligible && gifts.length) {
        var jobs = [];
        if (gifts[0].quantity !== 1) jobs.push(postCart("/cart/change.js", { id: gifts[0].key, quantity: 1 }));
        gifts.slice(1).forEach(function (item) { jobs.push(postCart("/cart/change.js", { id: item.key, quantity: 0 })); });
        if (jobs.length) return Promise.all(jobs);
      }
    }).then(function () {
      return cartJson();
    }).then(function (cart) {
      if (typeof window.hnOpenCart === "function" && document.querySelector(".drawer-root.is-open")) {
        window.hnOpenCart();
        window.setTimeout(function () { cartJson().then(paint); }, 250);
      } else {
        paint(cart);
      }
    }).catch(function (e) {
      console.error("HapNuts free saree setup:", e);
    }).finally(function () {
      busy = false;
      if (pending) { pending = false; syncGift(); }
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    return rawFetch(input, init).then(function (response) {
      if (!busy && response.ok && /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) {
        window.setTimeout(syncGift, 180);
      }
      return response;
    });
  };
  window.setTimeout(syncGift, 350);
  document.addEventListener("DOMContentLoaded", syncGift);
})();